module.exports = __webpack_public_path__ + "static/media/facebook_button.24a42e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/img/facebook_button.png
// module id = 394
// module chunks = 2